import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { WorkTable, MODULE_LABEL } from "@/components/work/WorkParts";
import OfficeMyWork from "@/pages/office/MyWork";

export default function MyWorkAll() {
  const [d, setD] = useState(null);
  const [mod, setMod] = useState("");
  const load = useCallback(() => api.get("/work/my").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  if (!d) return null;
  const rows = mod ? d.items.filter((r) => r.module === mod) : d.items;
  return (
    <div className="space-y-6" data-testid="my-work-all">
      <div>
        <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{d.user.department || "—"} · {d.user.designation || ""}</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight uppercase">My Work — {d.user.name}</h1>
        <p className="text-sm text-muted-foreground">Everything assigned to you across all modules. <span className="metric">{d.total}</span> pending · <span className={`metric ${d.overdue ? "text-signal-red" : ""}`}>{d.overdue}</span> overdue</p>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="my-work-modules">
        <button onClick={() => setMod("")} className={`text-[10px] font-mono uppercase tracking-widest px-2.5 py-1.5 rounded border ${!mod ? "bg-primary/15 text-primary border-primary/40" : "border-border text-muted-foreground"}`} data-testid="my-work-mod-all">All · {d.total}</button>
        {Object.entries(d.by_module).map(([m, v]) => (
          <button key={m} onClick={() => setMod(m)} className={`text-[10px] font-mono uppercase tracking-widest px-2.5 py-1.5 rounded border ${mod === m ? "bg-primary/15 text-primary border-primary/40" : "border-border text-muted-foreground"}`} data-testid={`my-work-mod-${m}`}>
            {MODULE_LABEL[m] || m} · {v.pending}{v.overdue ? <span className="text-signal-red"> · {v.overdue} late</span> : ""}</button>))}
      </div>
      <WorkTable rows={rows} showOwner={false} testid="my-work-table" />
      <details className="border-t border-border pt-4" data-testid="office-tasks-section">
        <summary className="cursor-pointer text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Office task board (detailed)</summary>
        <div className="mt-4"><OfficeMyWork /></div>
      </details>
    </div>
  );
}
